export const BrowserUtilService = {
    scrollToTop() {
        window.requestAnimationFrame(() => {
            window.scrollTo(0, 0);
        });
    },
};
